<template>
  <div :class="b()">
    <div :class="b('template')">
      <select :class="b('')" v-model="selectedSubGroup">
        <option v-for="subGroup in subGroups" :value="subGroup.id">
          {{ subGroup.title }}
        </option>
      </select>
      <el-button @click="getTemplate">Получить шаблон</el-button>
    </div>
    <div class="form-inline">
      <div class="form-group">
        <input class="form-control" type="file" id="csv-file" accept=".csv">
        <button :class="['btn', 'btn-primary', isLoading ? 'disabled': '']" id="loadData" @click="loadData">
          Загрузить
        </button>
        <div class="progress" v-if="isLoading">
          <div class="progress-bar progress-bar-striped progress-bar-animated active" role="progressbar"
               aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 75%"></div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <button class="btn btn-primary" v-on:click="addColumn">Добавить поле</button>
      <button class="btn btn-primary" v-on:click="addRow">Добавить строку</button>
      <button class="btn btn-primary" v-on:click="removeSelected">Удалить строки</button>
      <button class="btn btn-primary" v-on:click="copySelected">Скопировать строки</button>
      <button class="btn btn-primary" v-on:click="saveAsCsv">Сохранить в csv</button>
    </div>
    <ag-grid-vue style="width: auto; height: 500px;"
                 ref="catalogGrid"
                 class="ag-theme-balham"
                 :columnDefs="colDefs"
                 :rowData="rowData"

                 @grid-ready="onGridReady">
    </ag-grid-vue>
    <div id="alert-zone">
      <div v-for="(alertObject, idx) in loaderAlerts" :key="idx"
           :class="['alert', 'alert-dismissible', alertObject.type]" role="alert">
        {{ alertObject.text }}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from "vue";

    import {AgGridVue} from "ag-grid-vue";
    import {EventBus} from "../event-bus";
    import LoadDataHeader from "./ag-grid/load-data-header";

    import VuePapaParse from "vue-papa-parse";

    Vue.use(VuePapaParse);

    import CatalogLoaderService from "../services/CatalogLoaderService";

    const COMPONENT_NAME = 'catalog-loader';
    const MAIN_ATTRIBUTE = '*';

    export default {
        name: COMPONENT_NAME,
        components: {
            AgGridVue
        },
        data() {
            return {
                catalogGrid: null,
                csvFile: null,
                gridOptions: {},
                colDefs: [],
                rowData: [],
                gridApi: null,
                columnApi: null,
                fixedColumns: [
                    'Супер группа',
                    'Группа',
                    'Подгруппа',
                    'Наименование',
                    'Страна',
                    'Производитель',
                    'Описание',
                    'Ед. изм.',
                    'Ссылка на изображение',
                    'Цена'
                ],
                fixedAttributes: [
                    'Страна',
                    'Производитель'
                ],
                mainAttributes: [],
                loaderAlerts: [],
                subGroups: [],
                hasError: false,
                isLoading: false,
                selectedSubGroup: ''
            };
        },
        created() {
            EventBus.$on('change-column-name', this.updateColumnName);
            EventBus.$on('remove-column', this.removeColumn);
        },
        beforeMount() {
        },
        mounted: function () {
            this.getAllSubGroups();
            this.gridOptions = this.getGridOptions();
            this.catalogGrid = this.$refs.catalogGrid;

            this.gridOptions.onGridColumnsChanged = this.gridColumnsChanged;
            this.gridOptions.onCellValueChanged = this.cellValueChanged;

            this.csvFile = document.getElementById('csv-file');
            this.csvFile.addEventListener('change', this.readCsvFile, false);
        },
        watch: {
            selectedSubGroup: {
                handler(val) {
                    this.loadColumnDefsForSubGroup(val);
                }
            },
            isLoading: function (newVal) {

            }
        },
        methods: {
            onGridReady(params) {
                this.gridApi = params.api;
                this.columnApi = params.columnApi;
            },
            async getAllSubGroups() {
                let response = await CatalogLoaderService.getAllSubGroups();
                if (response.success) {
                    this.subGroups = response.subGroups;
                    console.log(this.subGroups);
                } else {
                    this.$message('Не удалось получить список всех категорий');
                }
            },
            async loadColumnDefsForSubGroup(subGroupId) {
                let self = this;
                let response = await CatalogLoaderService.getSubGroupAttributes(subGroupId);
                if (response.success) {
                    let attributes = response.attributes;

                    let colDefs = [];
                    let colIdx = 0;
                    for (let fixedIdx = 0; fixedIdx < self.fixedColumns.length; fixedIdx++) {
                        let column = self.fixedColumns[fixedIdx];
                        colDefs.push({headerName: column, field: 'attribute' + colIdx, editable: true});
                        colIdx++;
                    }

                    for (let attrIdx = 0; attrIdx < attributes.length; attrIdx++) {
                        let attribute = attributes[attrIdx];
                        if (self.fixedColumns.indexOf(attribute.name) !== -1) {
                            continue;
                        }
                        colDefs.push({headerName: attribute.name, field: 'attribute' + colIdx, editable: true});
                        colIdx++;
                    }

                    self.gridOptions.columnDefs = colDefs;
                    self.gridApi.setColumnDefs(self.gridOptions.columnDefs);

                    let newRowData = [];
                    self.rowData = newRowData;
                    self.gridApi.setRowData(self.rowData);
                }
            },
            async checkHierarchies() {
                let rowsData = [];
                this.gridApi.forEachNode((rowNode) => {
                    let superGroup = rowNode.data.attribute0;
                    let group = rowNode.data.attribute1;
                    let subGroup = rowNode.data.attribute2;
                    let rowStructure = {
                        superGroup: superGroup,
                        group: group,
                        subGroup: subGroup
                    };

                    rowsData.push(rowStructure);
                });

                let response = await CatalogLoaderService.checkHierarchy(rowsData);
                if (!response.success) {
                    let errors = response.error.message;
                    errors.forEach((error) => {
                        this.createAlert(error, 'alert-danger');
                    });
                }
            },
            checkEmptyValues: function (rowNode) {
                let self = this;
                let checkPromise = new Promise(function (resolve, reject) {
                    let data = rowNode.data;

                    let superGroup = data.attribute0;
                    if (superGroup && superGroup.trim().length === 0) {
                        self.createAlert('Для строки ' + (rowNode.rowIndex + 1) + ' не указана супер группа', 'alert-danger');
                    }

                    let group = data.attribute1;
                    if (group && group.trim().length === 0) {
                        self.createAlert('Для строки ' + (rowNode.rowIndex + 1) + ' не указана группа', 'alert-danger');
                    }

                    let subGroup = data.attribute2;
                    if (subGroup && subGroup.trim().length === 0) {
                        self.createAlert('Для строки ' + (rowNode.rowIndex + 1) + ' не указана подгруппа', 'alert-danger');
                    }

                    let name = data.attribute3;
                    if (name && name.trim().length === 0) {
                        self.createAlert('Для строки ' + (rowNode.rowIndex + 1) + ' не указано наименование', 'alert-danger');
                    }

                    let manufacture = data.attribute5;
                    if (manufacture && manufacture.trim().length === 0) {
                        self.createAlert('Для строки ' + (rowNode.rowIndex + 1) + ' не указан производитель', 'alert-danger');
                    }

                    resolve();
                });

                return checkPromise;
            },
            async checkDuplicates() {
                let colDefs = this.gridOptions.columnDefs;
                let rowsData = [];
                this.gridApi.forEachNode((rowNode) => {
                    let rowStructure = {};
                    for (let colIdx = 0; colIdx < colDefs.length; colIdx++) {
                        let colDef = colDefs[colIdx];
                        rowStructure['attribute' + colIdx] = {
                            name: colDef.headerName,
                            value: rowNode.data['attribute' + colIdx]
                        };
                    }
                    rowsData.push(rowStructure);
                });

                let response = await CatalogLoaderService.checkStructureDuplicate(rowsData);
                if (!response.success) {
                    let errors = response.error.message;
                    errors.forEach((error) => {
                        this.createAlert(error, 'alert-danger');
                    });
                }
            },
            async checkMainAttributes() {
                let colDefs = this.gridOptions.columnDefs;
                let mainAttributes = {};
                let anotherAttributes = {};
                let attributeValues = {};
                this.gridApi.forEachNode((rowNode) => {
                    let subGroup = rowNode.data.attribute2.trim();
                    for (let colIdx = 0; colIdx < colDefs.length; colIdx++) {
                        let curCol = colDefs[colIdx];
                        let name = curCol.headerName;
                        if (
                            this.fixedColumns.indexOf(name) !== -1 &&
                            this.fixedAttributes.indexOf(name) === -1
                        ) {
                            continue;
                        }

                        let collection = anotherAttributes;

                        if (this.mainAttributes.indexOf(colIdx) !== -1) {
                            collection = mainAttributes;
                        }

                        if (_.isUndefined(collection[subGroup])) {
                            collection[subGroup] = [];
                        }

                        if (collection[subGroup].indexOf(name) === -1) {
                            collection[subGroup].push(name);
                        }

                        if (_.isUndefined(attributeValues[name])) {
                            attributeValues[name] = [];
                        }

                        let attributeValue = rowNode.data['attribute' + colIdx].trim();
                        if (attributeValue.length === 0) {
                            continue;
                        }
                        if (attributeValues[name].indexOf(attributeValue) === -1) {
                            attributeValues[name].push(attributeValue);
                        }

                    }

                });

                let response = await CatalogLoaderService.checkAttributes(mainAttributes, anotherAttributes, attributeValues);
                if (!response.success) {
                    let errors = response.error.message;
                    errors.forEach((error) => {
                        this.createAlert(error, 'alert-danger');
                    })
                }
            },
            checkSubGroup: function () {
                let self = this;
                let checkPromise = new Promise(function (resolve, reject) {
                    let subGroups = [];
                    self.gridApi.forEachNode(function (rowNode) {
                        let subGroup = rowNode.data.attribute2;
                        if (subGroups.indexOf(subGroup) === -1) {
                            subGroups.push(subGroup);
                        }
                    });
                    if (subGroups.length > 1) {
                        self.createAlert('В одном сеансе можно обрабатывать не больше одной подгруппы', 'alert-danger');
                    }
                    resolve();
                });

                return checkPromise;
            },
            checkData: function () {
                let self = this;
                self.clearAlerts();

                let checkPromises = [];
                let structurePromise = this.checkTableStructure();
                checkPromises.push(structurePromise);

                let checkSubGroupPromise = self.checkSubGroup();
                checkPromises.push(checkSubGroupPromise);
                this.gridApi.forEachNode(function (rowNode) {
                    let checkEmptyPromise = self.checkEmptyValues(rowNode);
                    checkPromises.push(checkEmptyPromise);
                });

                let checkHierarchyPromise = self.checkHierarchies();
                checkPromises.push(checkHierarchyPromise);

                let checkAttributes = self.checkMainAttributes();
                checkPromises.push(checkAttributes);

                let checkDuplicates = self.checkDuplicates();
                checkPromises.push(checkDuplicates);


                return checkPromises;
            },
            loadData: function () {
                let self = this;
                self.hasError = false;
                self.isLoading = true;
                let checkPromises = this.checkData();
                Promise.all(checkPromises).then(function () {
                    if (!self.hasError) {
                        let arRows = [];
                        // Получить данные из таблицы в форме строк csv
                        let colDefs = self.gridOptions.columnDefs;
                        let headers = [];
                        for (let colIdx = 0; colIdx < colDefs.length; colIdx++) {
                            let curCol = colDefs[colIdx];
                            let name = curCol.headerName;
                            if (self.mainAttributes.indexOf(colIdx) !== -1) {
                                name = '*' + name;
                            }
                            headers.push(name);
                        }

                        self.gridApi.forEachNode(function (rowNode) {
                            let data = rowNode.data;
                            let rowData = [];
                            for (let key in data) {
                                let value = data[key];
                                rowData.push(value);
                            }
                            arRows.push(rowData);
                        })

                        let rowsForSend = [];
                        rowsForSend.push(headers);
                        let allLoadPromises = [];
                        let allDataLoaded = true;
                        let number = 1;
                        for (let rowIdx = 0; rowIdx < arRows.length; rowIdx++) {
                            let curRow = arRows[rowIdx];
                            rowsForSend.push(curRow);
                            if (rowsForSend.length === 20 || ((rowIdx + 1) == arRows.length)) {

                                let loadPromise = self.loadPartial(number, rowsForSend);
                                number++;
                                allLoadPromises.push(loadPromise);
                                rowsForSend = [];
                                rowsForSend.push(headers);
                            }
                        }

                        Promise.all(allLoadPromises).then(function () {
                            if (allDataLoaded) {
                                self.createAlert('Данные успешно загружены', 'alert-success');
                            } else {
                                self.createAlert('Произошла ошибка при загрузке данных', 'alert-success');
                            }
                            self.isLoading = false;
                        })
                    } else {
                        self.isLoading = false;
                    }
                });

            },
            async loadPartial(number, rows) {
                let response = await CatalogLoaderService.loadData(rows);
                if (response.success) {
                    if (response.loaded) {
                        this.createAlert(`Часть данных ${number} загружена`, 'alert-success');
                    } else {
                        this.createAlert(`Произошла ошибка при загрузке части данных ${number}`, 'alert-danger');
                    }
                }
            },
            cellValueChanged: function (e) {
                let self = this;
                let rowNode = this.gridApi.getDisplayedRowAtIndex(e.rowIndex);
            },
            getTemplate: function () {
                let exportParams = {
                    columnSeparator: ';',
                    shouldRowBeSkipped: function (params) {
                        return params.node.rowIndex >= 0;
                    }
                };

                this.gridApi.exportDataAsCsv(exportParams);
            },
            gridColumnsChanged: function () {
                this.setupColumns();
                this.checkData();
            },
            setupColumns: function () {
                let colDefs = this.gridOptions.columnDefs;
                let newColDefs = [];
                let colDef = colDefs[0];
                if (!colDef.hasOwnProperty('cellEditorParams')) {
                    for (let colIdx = 0; colIdx < colDefs.length; colIdx++) {
                        let colDef = colDefs[colIdx];

                        let headerName = colDef.headerName;
                        if (this.fixedColumns.indexOf(headerName) === -1) {
                            colDef.cellEditorParams = {
                                cellType: 'attribute',
                            };
                        } else if (headerName == 'Подгруппа') {
                            colDef.cellEditorParams = {
                                cellType: 'subgroup',
                                disableNewValue: true
                            };
                        } else if (headerName == 'Группа') {
                            colDef.cellEditorParams = {
                                cellType: 'group',
                                disableNewValue: true
                            }
                        } else if (headerName == 'Супер группа') {
                            colDef.cellEditorParams = {
                                cellType: 'super_group',
                                disableNewValue: true
                            }
                        } else if (headerName == 'Страна') {
                            colDef.cellEditorParams = {
                                cellType: 'country',
                            }
                        } else if (headerName == 'Производитель') {
                            colDef.cellEditorParams = {
                                cellType: 'manufacture',
                                disableNewValue: true
                            }
                        } else if (headerName == 'Ссылка на изображение') {
                            colDef.cellEditorParams = {
                                cellType: 'image'
                            }
                        } else if (headerName == 'Цена') {
                            colDef.cellEditorParams = {
                                cellType: 'price'
                            }
                        } else if (headerName == 'Ед. изм.') {
                            colDef.cellEditorParams = {
                                cellType: 'unit'
                            }
                        } else {
                            colDef.cellEditorParams = {
                                cellType: 'fixed'
                            };
                        }

                        colDef.headerComponentParams = {
                            removable: colDef.cellEditorParams.cellType === 'attribute',
                            canRename: colDef.cellEditorParams.cellType === 'attribute',
                            menuIcon: 'fa-bars'
                        };

                        if (colDef.cellEditorParams.cellType !== 'fixed') {
                            // colDef.cellEditorParams['propRepo'] = this.propertyRepo;
                            colDef.cellEditor = propertyEditor;
                        }
                        colDef.suppressMovable = true;

                        newColDefs.push(colDef);
                    }
                }
                if (newColDefs.length > 0) {
                    this.gridApi.setColumnDefs(newColDefs);
                }
            },
            clearAlerts: function () {
                this.loaderAlerts.splice(0, this.loaderAlerts.length);
                this.hasError = false;
            },
            createAlert: function (text, type) {
                if (type === 'alert-danger') {
                    this.hasError = true;
                }
                this.loaderAlerts.push({
                    text: text,
                    type: type
                });
            },
            updateColumnName: function (column, newName) {
                let colDef = column.colDef;
                let curColDefs = this.gridOptions.columnDefs;
                for (let colIdx = 0; colIdx < curColDefs.length; colIdx++) {
                    let curCol = curColDefs[colIdx];
                    if (curCol.field == colDef.field) {
                        this.gridOptions.columnDefs[colIdx].headerName = newName;
                    }
                }
                this.gridApi.setColumnDefs(this.gridOptions.columnDefs);
            },
            removeColumn: function (column) {
                let colDef = column.colDef;
                let curColDefs = this.gridOptions.columnDefs;
                for (let colIdx = 0; colIdx < curColDefs.length; colIdx++) {
                    let curCol = curColDefs[colIdx];
                    if (curCol.field == colDef.field) {
                        this.gridOptions.columnDefs.splice(colIdx, 1);
                        break;
                    }
                }
                this.gridApi.setColumnDefs(this.gridOptions.columnDefs);
            },
            getColumns: function () {
                return [
                    {headerName: 'Супер группа', field: 'attribute0', disableMoveColumn: true},
                    {headerName: 'Группа', field: 'attribute1', disableMoveColumn: true},
                    {headerName: 'Подгруппа', field: 'attribute2', disableMoveColumn: true},
                    {headerName: 'Наименование', field: 'attribute3', disableMoveColumn: true},
                    {headerName: 'Страна', field: 'attribute4', disableMoveColumn: true},
                    {headerName: 'Производитель', field: 'attribute5', disableMoveColumn: true},
                    {headerName: 'Описание', field: 'attribute6', disableMoveColumn: true},
                    {headerName: 'Ед. изм.', field: 'attribute7', disableMoveColumn: true},
                    {headerName: 'Ссылка на изображение', field: 'attribute8', disableMoveColumn: true},
                    {headerName: 'Цена', field: 'attribute9', disableMoveColumn: true}
                ];
            },
            getRowsData: function () {
                return this.rowData;
            },
            getGridOptions: function () {
                this.getColumnDefs();
                return {
                    columnDefs: this.colDefs,
                    rowData: this.getRowsData(),
                    suppressMenuHide: true,
                    suppressRowClickSelection: true,
                    rowSelection: 'multiple',
                    animateRows: true,
                    components: {
                        agColumnHeader: LoadDataHeader
                    },
                    defaultColDef: {}
                }
            },
            getColumnDefs() {
                let colDefs = this.getColumns();
                for (let colIdx = 0; colIdx < colDefs.length; colIdx++) {
                    let colDef = colDefs[colIdx];
                    colDef.editable = true;
                }
                this.colDefs = colDefs;
            },
            addColumn: function () {
                let columnDefs = this.gridOptions.columnDefs;
                let attributeCount = columnDefs.length;
                let newColDefs = [];
                for (let colIdx = 0; colIdx < columnDefs.length; colIdx++) {
                    let colDef = columnDefs[colIdx];
                    newColDefs.push({headerName: colDef.headerName, field: colDef.field, editable: true});
                }
                newColDefs.push({headerName: 'Новый столбец', field: 'attribute' + attributeCount, editable: true});
                this.gridOptions.columnDefs = newColDefs;
                this.gridApi.setColumnDefs(this.gridOptions.columnDefs);

            },
            addRow: function () {
                let columnDefs = this.gridOptions.columnDefs;
                let row = {};
                for (let colIdx = 0; colIdx < columnDefs.length; colIdx++) {
                    let colDef = columnDefs[colIdx];
                    row[colDef.field] = ' ';
                }

                this.gridApi.updateRowData({add: [row]});

            },
            removeSelected: function () {
                let selectedRowData = this.gridApi.getSelectedRows();
                this.gridApi.updateRowData({remove: selectedRowData});
            },
            saveAsCsv: function () {
                let exportParams = {
                    columnSeparator: ';',
                    fileName: 'data'
                };

                this.gridApi.exportDataAsCsv(exportParams);
            },
            copySelected: function () {
                let rowCount = 0;
                this.gridApi.forEachNode(function (rowNode) {
                    rowCount++;
                });

                let selectedRowData = this.gridApi.getSelectedRows();
                let newRowData = [];
                for (let rowIdx = 0; rowIdx < selectedRowData.length; rowIdx++) {
                    let rowData = _.cloneDeep(selectedRowData[rowIdx]);
                    newRowData.push(rowData);
                }
                this.gridApi.updateRowData({add: newRowData});
            },
            async checkIsAttribute(headerName) {
                let self = this;
                let response = await CatalogLoaderService.checkIsAttribute(headerName);
                if (response.success && response.hasOwnProperty('attribute_name')) {
                    self.createAlert('Новый атрибут ' + response.attribute_name, 'alert-warning');
                }
            },
            checkTableStructure: function () {
                let self = this;
                let checkPromise = new Promise(function (resolve, reject) {
                    let colDefs = self.gridOptions.columnDefs;
                    let colNames = [];
                    let attributePromises = [];
                    for (let colIdx = 0; colIdx < colDefs.length; colIdx++) {
                        let curCol = colDefs[colIdx];
                        let headerName = curCol.headerName;
                        colNames.push(headerName);
                        if (self.fixedColumns.indexOf(headerName) === -1) {
                            let checkPromise = self.checkIsAttribute(headerName);
                            attributePromises.push(checkPromise);
                        }
                    }

                    for (let colIdx = 0; colIdx < self.fixedColumns.length; colIdx++) {
                        let curCol = self.fixedColumns[colIdx];
                        if (colNames.indexOf(curCol) === -1) {
                            self.createAlert('В шаблоне таблицы нет обязательного поля ' + curCol, 'alert-danger');
                        }
                    }

                    Promise.all(attributePromises).then(resolve()).catch(reject());
                });

                return checkPromise;
            },
            readCsvFile: function (evt) {
                let self = this;
                let files = evt.target.files;
                let file = files[0];
                this.$papa.parse(file, {
                    delimeter: ';',
                    skipEmptyLines: true,
                    complete: function (fileRows) {
                        let data = fileRows.data;
                        let arHeaders = data[0];
                        self.checkHeader(arHeaders);
                        if (self.hasError) {
                            return;
                        }
                        let colDefs = [];
                        for (let colIdx = 0; colIdx < arHeaders.length; colIdx++) {
                            let colName = arHeaders[colIdx];
                            let firstSymbol = colName.substring(0, 1);
                            if (firstSymbol === MAIN_ATTRIBUTE) {
                                self.mainAttributes.push(colIdx);
                                colName = colName.substring(1);
                            }

                            colDefs.push({headerName: colName, field: 'attribute' + colIdx, editable: true});
                        }
                        self.gridOptions.columnDefs = colDefs;
                        self.gridApi.setColumnDefs(self.gridOptions.columnDefs);

                        let newRowData = [];
                        for (let rowIdx = 1; rowIdx < data.length; rowIdx++) {
                            let csvRowData = data[rowIdx];
                            let gridRow = {};
                            for (let colIdx = 0; colIdx < csvRowData.length; colIdx++) {
                                let colDef = colDefs[colIdx];
                                gridRow[colDef.field] = csvRowData[colIdx].trim();
                            }
                            newRowData.push(gridRow);
                        }
                        self.rowData = newRowData;
                        self.gridApi.setRowData(self.rowData);
                        self.checkData();
                    }
                });

            },
            checkHeader(header) {
                this.clearAlerts();
                header.forEach((element, idx) => {
                    let checkIdxs = [0, 1, 2, 3];
                    if (checkIdxs.indexOf(idx) !== -1) {
                        if (element !== this.fixedColumns[idx]) {
                            this.createAlert(`Не правильный стоблбец ${idx + 1}, наименование должно быть ${this.fixedColumns[idx]}, а в файле ${element}`, 'alert-danger');
                        }
                    }
                });
            }
        }
    }

</script>

<style scoped lang="scss">
  @import "~ag-grid-community/dist/styles/ag-grid.css";
  @import "~ag-grid-community/dist/styles/ag-theme-balham.css";

  .catalog-loader {
    display: flex;
    flex-direction: column;
  }
</style>